<div [innerHTML]="module.settings.content.html | safeHtml"></div>